export const initialCreateRegoleData = {
  data: {
    destinationTypes: [],
    fdnList: [],
    fdnGroupList: [],
    vocalMessagesList: [],
    odrList: [],
    tdrList: [],
    barringList: [],
    messagiVocaliSuBaseOrigineList: [],
    whiteList: [],
    menuServiceList: [],
    currentItemList: [],
  },
  loading: false,
};

export const initialSelectedApplicationRule = {
  data: {
    nedId: "",
    nedName: "",
    applicationRuleObjectList: [],
  },
  loading: false,
};
